import React, { useState, useEffect, useRef } from 'react'
import { Formik, Form } from 'formik'
import { Link, useParams } from 'react-router-dom'
import Yup, { validaData } from '../../../../util/Validacoes'
import { HeaderCadastro } from '../../../../components/Headers'
import { mostrarToast } from '../../../../components/Toasts'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import { get, salvar } from '../../../../util/AcessoApi'
import { ModalDuasOpcoes } from '../../../../components/Modais'
import { InputPadrao, InputMascaraSimples } from '../../../../components/Inputs'
import { obterGuiasParaImportacaoEspecificas } from '../../../../util/FuncoesComuns'
import Atalho from '../../../../util/Atalho'
import '../../../../assets/css/icones/iconsmind/style.css'

import TabelaGuias from './components/TabelaGuias'
import ModalFiltrosGuias from './components/ModalFiltrosGuias'
import ModalDadosLancamentos from './components/ModalDadosLancamentos'
import ModalLoteGerado from './components/ModalLoteGerado'
import ListaLancamentosLote from './components/ListaLancamentosLote'

const parseValorFormatado = (str) => {
    const s = (str || '').toString()
        .replace(/[^\d,.-]/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
    return parseFloat(s) || 0
}

export default props => {
    let { id } = useParams()
    const ehAlteracao = !!id

    const [abrirModalLancamento, setAbrirModalLancamento] = useState(false)
    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({ modalAberto: false, filtros: { lote: '' }, guias: [] })
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')
    const [guias, setGuias] = useState([])
    const [totalSelecionados, setTotalSelecionados] = useState(0)
    const [carregando, setCarregando] = useState(false)
    const [loteCriado, setLoteCriado] = useState(null)
    const [showModalLote, setShowModalLote] = useState(false)
    const [lote, setLote] = useState(null)
    const [lancamentosLote, setLancamentosLote] = useState([])
    const [lancamentosRemover, setLancamentosRemover] = useState([])
    const refGuias = useRef(null)

    const [validacao] = useState(Yup.lazy(values => Yup.object().shape({
        guias: Yup.array()
            .test('Guias', 'Selecione ao menos uma Guia', function () {
                return this.parent.guias && this.parent.guias.length
            }),
        cliente_lancamento: values?.tentouSalvarLancamento ? Yup.object().nullable().required('Campo Obrigatório') : Yup.mixed().nullable(),
        empresa: values?.tentouSalvarLancamento ? Yup.object().nullable().required('Campo Obrigatório') : Yup.mixed().nullable(),
        categoria_lancamento: values?.tentouSalvarLancamento ? Yup.object().nullable().required('Campo Obrigatório') : Yup.mixed().nullable(),
        previsao_vencimento_lancamento: values?.tentouSalvarLancamento ? Yup.string().nullable().required('Campo Obrigatório') : Yup.string().nullable(),
        modo_liquidacao: values?.tentouSalvarLancamento ? Yup.object().nullable().required('Campo Obrigatório') : Yup.mixed().nullable(),
        data_liquidacao: values?.tentouSalvarLancamento ? Yup.string().nullable().required('Campo Obrigatório') : Yup.string().nullable(),
        filtros: Yup.object().shape({
            data_inicial_procedimento: Yup.string().nullable()
                .test('Data Inicial', 'Data inválida!', function () { return validaData(this.parent.data_inicial_procedimento) }),
            data_final_procedimento: Yup.string().nullable()
                .test('Data Final', 'Data inválida!', function () { return validaData(this.parent.data_final_procedimento) }),
            data_inicial_registro: Yup.string().nullable()
                .test('Data Inicial', 'Data inválida!', function () { return validaData(this.parent.data_inicial_registro) }),
            data_final_registro: Yup.string().nullable()
                .test('Data Final', 'Data inválida!', function () { return validaData(this.parent.data_final_registro) }),
        })
    })))

    useEffect(() => {
        if (!ehAlteracao) {
            setValoresIniciais({ lote: '', guias: [], modalAberto: false, filtros: { lote: '' } })
            return
        }
        Promise.resolve(get(`/financeiro/loteLancamento/${id}`)).then(obj => {
            if (!obj) {
                props.history.push('/financeiro/loteLancamento/consulta')
                return
            }
            setLote({
                id: obj.id,
                codigo: obj.codigo,
                estabelecimento: obj.estabelecimento,
                estabelecimentos: obj.estabelecimentos || [],
                data_registro: obj.data_registro
            })
            setLancamentosLote(obj.lancamentos || [])
            setLancamentosRemover([])
            setValoresIniciais({ lote: '', guias: [], modalAberto: false, filtros: { lote: '' } })
        })
    }, [id])

    const buscarPorCampo = (campo, valor, propsFormik, restaurarFocoAposBusca = false) => {
        const inputId = campo === 'codigo_barras' ? 'codigo_barras' : 'codigo_id'
        const restaurarFoco = () => setTimeout(() => {
            const el = document.getElementById(inputId)
            if (el) el.focus()
        }, 0)
        setCarregando(true)
        if (valor && valor.length > 0)
            obterGuiasParaImportacaoEspecificas({ [campo]: valor }, val => {
                setGuias([
                    ...(val.filter(x => !guias.find(y => y.id === x.id))).map(x => ({ especifica: true, ...x })),
                    ...guias
                ])
                setCarregando(false)
                propsFormik.setFieldValue(inputId, '')
                propsFormik.setFieldTouched('guias', false)
                if (restaurarFocoAposBusca) restaurarFoco()
            })
        else
            setCarregando(false)
    }

    const salvarPromise = (data, url) => new Promise((resolve, reject) => {
        salvar(data, url, resolve, reject)
    })

    const Submit = async (values) => {
        setSalvando(true)
        try {
            const cloneValues = { ...values }
            delete cloneValues.filtros
            delete cloneValues.modalAberto
            cloneValues.guias = (cloneValues.guias || []).map(item => item.id)
            if (ehAlteracao) cloneValues.lote_id = lote?.id

            const resp = await salvarPromise({ ...cloneValues }, '/financeiro/importarGuiasLancamento')

            if (ehAlteracao && lancamentosRemover.length > 0)
                await salvarPromise(
                    { id: lote.id, lancamentos_remover: lancamentosRemover },
                    '/financeiro/loteLancamento'
                )

            mostrarToast('sucesso', mensagens.sucesso)
            setAbrirModalLancamento(false)
            setSalvando(false)
            if (ehAlteracao) {
                setLancamentosRemover([])
                props.history.push('/financeiro/loteLancamento/consulta')
            } else {
                setLoteCriado({ codigo: resp?.codigo, estabelecimento: resp?.estabelecimento, quantidade: resp?.quantidade })
                setShowModalLote(true)
            }
        } catch {
            setSalvando(false)
        }
    }

    const fecharModalLote = () => {
        setShowModalLote(false)
        setLoteCriado(null)
        props.history.push('/financeiro/loteLancamento/consulta')
    }

    const funcaoAposSim = (formik) => {
        setShowModalValidacao(false)
        Submit(formik.values)
    }

    const removerLancamento = (item) => {
        console.log('---item: ', item);
        if (!item) return
        setLancamentosLote(prev => prev.filter(x => x.id !== item.id))
        setLancamentosRemover(prev => [...prev, item.id])
        console.log('Aqui foi');
    }

    const salvarRemocoes = () => {
        if (!lancamentosRemover.length) {
            mostrarToast('erro', 'Nenhum lançamento foi marcado para remoção.')
            return
        }
        setSalvando(true)
        salvar(
            { id: lote.id, lancamentos_remover: lancamentosRemover },
            '/financeiro/loteLancamento',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                setLancamentosRemover([])
                setSalvando(false)
                props.history.push('/financeiro/loteLancamento/consulta')
            },
            () => {
                setSalvando(false)
                mostrarToast('erro', mensagens.erro)
            }
        )
    }

    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Financeiro</span>,
        () => <Link className='link-active' to={'/financeiro/loteLancamento/consulta'}>Lote de Lançamentos</Link>
    ]

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => {
                if (values?.tentouSalvarLancamento) {
                    Submit(values)
                } else {
                    const filtroEstab = values?.filtros?.estabelecimento_saude
                    const estabSelecionado = Array.isArray(filtroEstab) ? filtroEstab[0] : filtroEstab
                    if (estabSelecionado && !values?.estabelecimento_saude)
                        propsFormik.setFieldValue('estabelecimento_saude', estabSelecionado)
                    setAbrirModalLancamento(true)
                }
            }}>
            {propsFormik => {
                const valorTotalSelecionados = (propsFormik.values.guias || [])
                    .reduce((acc, g) => acc + parseValorFormatado(g.valor_total_formatado), 0)
                    .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

                return (
                    <>
                        <Form>
                            {!props.modal && <HeaderCadastro
                                titulo={ehAlteracao ? 'Alteração de Lote de Lançamentos' : 'Importação de Atendimento - Lançamentos'}
                                link={links} />}

                            <div className={props.modal && props.modal || 'card mb-20'}>
                                <div className={props.modal || 'card-body'}>
                                    {ehAlteracao && <h5 className='mb-3'>Adicionar Lançamentos</h5>}
                                    <div className='col-12'>
                                        <div className='row'>
                                            <div className='col-6 row'>
                                                <InputMascaraSimples
                                                    disabled={carregando}
                                                    mascara="111.111.111-11"
                                                    tamanho="col-6"
                                                    name="codigo_barras"
                                                    id="codigo_barras"
                                                    type="text"
                                                    placeholder="Código Barras"
                                                    onBlur={(e) => buscarPorCampo('codigo_barras', e.target.value, propsFormik, false)}
                                                    onKeyDown={(e) => { if (e.keyCode === 13) e.preventDefault() }}
                                                    onKeyUp={(e) => {
                                                        e.preventDefault()
                                                        if (e.keyCode === 13) buscarPorCampo('codigo_barras', e.target.value, propsFormik, true)
                                                    }}
                                                />
                                                <InputPadrao
                                                    disabled={carregando}
                                                    tamanho="col-6"
                                                    name="codigo_id"
                                                    id="codigo_id"
                                                    type="text"
                                                    placeholder="Código"
                                                    onBlur={(e) => buscarPorCampo('codigo', e.target.value, propsFormik, false)}
                                                    onKeyDown={(e) => { if (e.keyCode === 13) e.preventDefault() }}
                                                    onKeyUp={(e) => {
                                                        e.preventDefault()
                                                        if (e.keyCode === 13) buscarPorCampo('codigo', e.target.value, propsFormik, true)
                                                    }}
                                                />
                                            </div>
                                            <div className='col-6 text-right'>
                                                <BotaoPadrao texto='Limpar' type='button' click={() => {
                                                    setGuias([])
                                                    document.getElementById('codigo_barras').focus()
                                                }} idTooltip='Filtros' />
                                                <BotaoPadrao texto='Filtros' type='button'
                                                    click={() => propsFormik.setFieldValue('modalAberto', true)} idTooltip='Filtros' />
                                            </div>
                                        </div>
                                        <div className='col-12 row mb-2'>
                                            <span style={{ marginTop: 15 }}>{`Guia(s) Selecionada(s): `} <b>{totalSelecionados}</b></span>
                                            <span style={{ marginTop: 15, marginLeft: 15 }}>{`Valor Total: `} <b>{valorTotalSelecionados}</b></span>
                                        </div>

                                        <TabelaGuias
                                            propsFormik={propsFormik}
                                            guias={guias}
                                            setGuias={setGuias}
                                            totalSelecionados={totalSelecionados}
                                            setTotalSelecionados={setTotalSelecionados}
                                            refGuias={refGuias}
                                            carregando={carregando}
                                        />
                                    </div>
                                    <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />
                                </div>
                            </div>

                            {ehAlteracao && (
                                <ListaLancamentosLote
                                    lancamentos={lancamentosLote}
                                    onRemoverItem={removerLancamento}
                                />
                            )}

                            {!props.modal && <div className='separator mt-40 mb-5'></div>}
                            <div className='direita container-botoes mb-3 group-salvar-novo'>
                                <BotaoPadrao
                                    texto={ehAlteracao ? 'Salvar e Continuar' : 'Continuar'}
                                    disabled={salvando}
                                    click={() => {
                                        setSalvarENovo(false)
                                        const temNovasGuias = (propsFormik.values.guias || []).length > 0
                                        if (ehAlteracao && !temNovasGuias && lancamentosRemover.length > 0) {
                                            salvarRemocoes()
                                        } else if (ehAlteracao && !temNovasGuias && lancamentosRemover.length === 0) {
                                            mostrarToast('erro', 'Nada para salvar.')
                                        } else {
                                            propsFormik.submitForm()
                                        }
                                    }}
                                    idTooltip={'salvar'} />
                            </div>

                            <ModalFiltrosGuias propsFormik={propsFormik} guias={guias} setGuias={setGuias} setCarregando={setCarregando} />
                        </Form>

                        <ModalDuasOpcoes
                            showModal={showModalValidacao}
                            setShowModal={setShowModalValidacao}
                            funcaoOpcao2={() => funcaoAposSim(propsFormik)}
                            funcaoOpcao1={() => { setSalvando(false); setShowModalValidacao(false) }}
                            esconderFechar
                            mensagem={<>{<>{'Validações do Lote:'} <br /><br /></>} {mensagemModal}<br />{'Deseja Continuar?'}</>}
                            textoOpcao1={'Cancelar'}
                            classeOpcao1={'btn-sm btn-primary-modal simples'}
                            textoOpcao2={'Continuar'}
                        />

                        <ModalDadosLancamentos
                            propsFormik={propsFormik}
                            showModal={abrirModalLancamento}
                            setShowModal={setAbrirModalLancamento}
                            salvando={salvando}
                            modal={props.modal}
                            tabLancamento={props.tabLancamento}
                            id={id}
                        />

                        <ModalLoteGerado
                            showModal={showModalLote}
                            setShowModal={setShowModalLote}
                            loteCriado={loteCriado}
                            onFechar={fecharModalLote}
                        />
                    </>
                )
            }}
        </Formik>
    )
}
